import { render, staticRenderFns } from "./ImageItem.vue?vue&type=template&id=2dece012&"
import script from "./ImageItem.vue?vue&type=script&lang=js&"
export * from "./ImageItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports